import angular from "angular";
import angularMask from "angular-ui-mask";
import core from "../../core/core.module";

angular
    .module('usersControl.userForm', [angularMask, core])
    .component('userForm', {
        controller: ['User', 'notifier', controller],
        template: require('./user-form.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(User, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.user = $ctrl.resolve.user;
        $ctrl.lastName = $ctrl.user.last_name;
        $ctrl.firstName = $ctrl.user.first_name;
        $ctrl.email = $ctrl.user.email;
        $ctrl.phone = $ctrl.user.phone;
        $ctrl.position = $ctrl.user.position;
        $ctrl.code = $ctrl.user.code;
        $ctrl.isActive = $ctrl.user.is_active;
    };

    $ctrl.submit = function () {
        $ctrl.loading = true;
        $ctrl.errorMessages = null;
        let params = {
            last_name: $ctrl.lastName,
            first_name: $ctrl.firstName,
            email: $ctrl.email,
            phone: $ctrl.phone,
            is_active: $ctrl.isActive,
            position: $ctrl.position,
            code: $ctrl.code,
        };
        User
            .update($ctrl.user.id, params)
            .then(
                function () {
                    $ctrl.loading = false;
                    notifier.successNotify('Данные пользователя успешно обновились');
                    $ctrl.close({
                        $value: params
                    });
                },
                function (error) {
                    $ctrl.loading = false;
                    notifier.errorResponseNotify(error);
                }
            );
    };

}

export default 'usersControl.userForm';


// WEBPACK FOOTER //
// ./resources/assets/modules/users-control/user-form/user-form.js